import { createMutationHelper } from '@utils/swr'
import { type UserResponse } from '../../../types/apiResponse'
import { type CosignApis } from '../../../types/apis'

const { useMutation } = createMutationHelper<CosignApis['patch']['updateUser'], UserResponse, { name: string }>({
  client: 'cosign',
  key: '/api/platform-sdk/user',
  fetcher: (url, { arg, client }) => {
    return client.patch(url, arg)
  },
})

export const useRequestUpdateUser = useMutation
